import { Outlet } from "@tanstack/react-router"
import Footer from "@/content/Footer"
import Nav from "@/content/Nav"

export default function PublicRoute() {
  return (
    <div className="mx-auto max-w-250 bg-background text-foreground">
      <Nav />
      <Outlet />
      <Footer />
    </div>
  )
}
